import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import store from './store';
import { initContentConfig } from '@/config/contentConfig';
import ErrorBoundary from '@/components/ErrorBoundary';
import globalErrorHandler from '@/utils/globalErrorHandler';
import '@/shims/patchResizeObserver';
import './index.less';

// logger 可在需要时用于记录初始化日志
// import logger from '@/utils/logger';

// 初始化内容配置
initContentConfig();

// 初始化全局异常监听
globalErrorHandler.init();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <ErrorBoundary>
    <Provider store={store}>
      <App />
    </Provider>
  </ErrorBoundary>
);
